import React, { useMemo } from "react";

import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "../../styles/theme";

// import AnalyticsContext from "../../contexts/Analytics";
// import useAnalyticsState from "../../contexts/Analytics/use-analytics-state";
import { ServiceWorkerStatus } from "../../service-worker/register";
import { useAppUrl } from "../../helpers/use-app-url";

import UIContext from "../../contexts/UIContext";
import { useUIState } from "../../contexts/UIContext/use-ui-state";
import WeatherContext from "../../contexts/WeatherContext";
import useWeatherState from "../../contexts/WeatherContext/use-weather-state";
import TimelineContext from "../../contexts/TimelineContext";
import { TropicalStormsContext } from "../../contexts/TropicalStorms";
import useTropicalStormsState from "../../contexts/TropicalStorms/use-tropical-storms-state";
import RailContext, { useRailState } from "../../contexts/RailContext";

type WeatherAppStateManagerProps = {
  serviceWorkerStatus?: ServiceWorkerStatus;
};

/** Centralized state management for the Wayfinder app.
 *  This component handles temporary and persistent storage of all shared
 *  application state and provides it to children components through a number
 *  of more tightly scoped React Contexts. These contexts also provide callback
 *  methods that can be used by children to trigger changes in application
 *  state. It's like redux, but less dogmatic. */
const WeatherAppStateManager: React.FC<WeatherAppStateManagerProps> = ({
  children,
  serviceWorkerStatus,
}) => {
  // Setup analytics
  // const analyticsValue = useAnalyticsState();
  // const trackAnalyticsEvent = analyticsValue.trackAnalyticsEvent;

  const {
    timeAtPageLoad,
    currentSimulatorTime,
    setCurrentSimulatorTime,
    // simulatedHistoricalTime,
  } = useAppUrl();

  const weatherValue = useWeatherState({ timeAtPageLoad });

  const uiValue = useUIState({
    serviceWorkerStatus,
    // trackAnalyticsEvent,
    getRequestTimes: weatherValue.getRequestTimes,
  });

  const timelineValue = useMemo(
    () => ({
      timeAtPageLoad,
      currentSimulatorTime,
      setCurrentSimulatorTime,
    }),
    [timeAtPageLoad, currentSimulatorTime, setCurrentSimulatorTime]
  );

  const tropicalStormState = useTropicalStormsState();
  const railState = useRailState();

  /*
    <AnalyticsContext.Provider value={analyticsValue}>
    </AnalyticsContext.Provider>
  */
  return (
    <RailContext.Provider value={railState}>
      <TimelineContext.Provider value={timelineValue}>
        <UIContext.Provider value={uiValue}>
          <WeatherContext.Provider value={weatherValue}>
            <TropicalStormsContext.Provider value={tropicalStormState}>
              <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </TropicalStormsContext.Provider>
          </WeatherContext.Provider>
        </UIContext.Provider>
      </TimelineContext.Provider>
    </RailContext.Provider>
  );
};

const ConnectedWeatherAppStateManager: React.FC<
  WeatherAppStateManagerProps
> = ({ children, serviceWorkerStatus }) => (
  <WeatherAppStateManager serviceWorkerStatus={serviceWorkerStatus}>
    {children}
  </WeatherAppStateManager>
);
export default ConnectedWeatherAppStateManager;
